import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {CheckIcon} from '../icons/CheckIcon'

/* This component renders 2 text buttons but you can add others later on. It provides option to render 3 different styles
   of buttons: success, fail, warning (which represents font color for each of the texts). Because the checkMark state
   needs to be set from database results when component is mounted, the state is completly managed parent. This component
   is solely a presentation component. To see what is need on parent, see commented area at bottom of file.    */
const TextButtonGroup = (props) => {

    /* Handlers for each of the buttons; Handlers can be added for additional buttons.  The handle calls parent handler 
       letting it know what button was clicked */
    const onClickHandler1 = () => {
        props.onClickHandler(1);
    }
    const onClickHandler2 = () => {
        props.onClickHandler(2);
    }

    /* Renders a check mark based on the props.checkMarks object sent down from parent. Basic structure is { checkMark1: true, checkMark2: false} 
       The parent is responsible for toggling the checkMark. */
    const renderCheckMark = (buttonNumber) => {
        let propertyName = `checkMark${buttonNumber}`;    /* propertyName will result in checkMark1 or checkMark2, etc */
        return  props.checkMarks[propertyName] ? <CheckIcon /> : null;
    }

    const renderLabel = (labelText) => {
        return (
            <div className="text-button-group-label">{labelText} </div>
        )
    }

    // Return  JSX

    /* intialize working variables */
    let buttonText1,  buttonText2   = "";
    let buttonStyle1, buttonStyle2  = "";

    /* intialize props */
    let { buttonGroupLabel, button1TextAndStyle, button2TextAndStyle} = props;

    /* split out text and style from the button props provided */
    if (button1TextAndStyle) {
        let button1  = button1TextAndStyle.split(":");
        buttonText1  = button1[0]; 
        buttonStyle1 = button1[1];
    }
    if (button2TextAndStyle) {
        let button2  = button2TextAndStyle.split(":");
        buttonText2  = button2[0];
        buttonStyle2 = button2[1];
    }

    return (
        
        <div className="text-button-group-container">
            <div>
                {renderLabel(buttonGroupLabel)}
            </div>

            <div style={{display: "flex"}}>
            { buttonText1 && (
                <div>
                <button className={`text-button-group-button text-button-group-${buttonStyle1}`}
                    onClick={onClickHandler1}
                >
                    {buttonText1}
                    {!props.clearCheckMarks && renderCheckMark(1)}
                </button>
                
                </div>
            )}
            { buttonText2 && (
                <button className={`text-button-group-button text-button-group-${buttonStyle2}`}
                        onClick={onClickHandler2}
                >
                    {buttonText2}
                    {!props.clearCheckMarks && renderCheckMark(2)}
                </button>
            )}
            </div>
        </div>
    )
}

TextButtonGroup.propTypes = {
    button1TextAndStyle:  PropTypes.string.isRequired,
    button2TextAndStyle:  PropTypes.string,
    buttonGroupLabel:     PropTypes.string,
    buttonClicked:        PropTypes.number,    /* self explanatory. value is either 1, 2, etc */ 
    onClickHandler:       PropTypes.func,
    clearCheckMarks:      PropTypes.bool,      /* parent can clear checkMarks if user cancelled a Modal that required more info, for example */ 
    checkMarks:           PropTypes.object     /* object of checkmarks for each text button. For example {checkMark1: true, checkMark2: false} */
};

export default TextButtonGroup;


//   STATE VALUES NEEDED ON PARENT
//   ==================================

//   buttonClickedValue: 0,   
//   textButtonCheckMarks: {checkMark1: false,  checkMark2: false},  

//   BASIC HANDLER ON PARENT 
//   =========================
 
//   handleTextButtonGroup() {

//      let { textButtonCheckMarks } = this.state;

//      /* Since user just clicked a text button, lets toggle the checkMark for the button clicked so code below can see the new state */
//      let checkMark1 = buttonClickedValue === 1 ?   !textButtonCheckMarks.checkMark1 : textButtonCheckMarks.checkMark1 ;
//      let checkMark2 = buttonClickedValue === 2 ?   !textButtonCheckMarks.checkMark2 : textButtonCheckMarks.checkMark2 ;

//      if (buttonClickedValue === 1 && checkMark1) {       /* button 1 clicked and ChecMark1 has change to true */
        // this.setState((state) => {
        //     return {
        //         rsvpFlag: "yes", 
        //         buttonClickedValue, 
        //         textButtonCheckMarks: { checkMark1: checkMark1,  checkMark2: false }, /* toggle checkmark */
        //     }
        // })
        // } else 
        // if (buttonClickedValue === 1 && !checkMark1) {       /* button 1 clicked and ChecMark1 has change to false */
        //     this.setState((state) => {
        //         return {
        //             rsvpFlag: "", 
        //             buttonClickedValue, 
        //             textButtonCheckMarks: { checkMark1: checkMark1,  checkMark2: false }, /* toggle checkmark */
        //         }
        //     })
        // } else 
        // if (buttonClickedValue === 2 &&  checkMark2) {
        //     this.setState((state) => {
        //         return {
        //             rsvpFlag: "no", 
        //             buttonClickedValue, 
        //             textButtonCheckMarks: { checkMark1: false,  checkMark2: checkMark2 }, /* toggle checkmark */
        //         }
        //     })
        // } else
        // if (buttonClickedValue === 2 && !checkMark2) {
        //     this.setState((state) => {
        //         return {
        //             rsvpFlag: "", 
        //             buttonClickedValue, 
        //             textButtonCheckMarks: { checkMark1: false,  checkMark2: checkMark2 }, /* toggle checkmark */
        //         }
        //     })
        // } 
        // 
//     HOW TO RENDER ON PARENT
//     =========================
//     <div className="text-button-group-container">
//         <TextButtonGroup 
//             buttonGroupLabel="Will you be Attending?"
//             button1TextAndStyle="Yes:success"
//             button2TextAndStyle="No:fail"
//             buttonClicked={this.state.buttonClickedValue}
//             checkMarks={this.state.textButtonCheckMarks}
//             onClickHandler={this.handleTextButtonGroup}
//             clearCheckMarks={this.state.clearNameEmailModalCheckMarks}
//         />
//     </div>




// WEBPACK FOOTER //
// ./src/components/buttons/TextButtonGroup.js